var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chats-fill (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.375 10.5C25.375 10.0359 25.1906 9.59075 24.8624 9.26256C24.5342 8.93437 24.0891 8.75 23.625 8.75H20.125V5.25C20.125 4.78587 19.9406 4.34075 19.6124 4.01256C19.2842 3.68437 18.8391 3.5 18.375 3.5H4.375C3.91087 3.5 3.46575 3.68437 3.13756 4.01256C2.80937 4.34075 2.625 4.78587 2.625 5.25V19.25C2.62551 19.4146 2.67245 19.5758 2.76043 19.7149C2.84841 19.854 2.97385 19.9655 3.12234 20.0366C3.27084 20.1076 3.43637 20.1353 3.59991 20.1165C3.76345 20.0977 3.91837 20.0332 4.04688 19.9303L7.875 16.8438V20.125C7.875 20.5891 8.05937 21.0342 8.38756 21.3624C8.71575 21.6906 9.16087 21.875 9.625 21.875H19.8614L23.9531 25.1803C24.108 25.3055 24.3009 25.3742 24.5 25.375C24.7321 25.375 24.9546 25.2828 25.1187 25.1187C25.2828 24.9546 25.375 24.7321 25.375 24.5V10.5ZM20.7211 20.3197C20.5663 20.1945 20.3734 20.1258 20.1742 20.125H9.625V16.625H18.375C18.8391 16.625 19.2842 16.4406 19.6124 16.1124C19.9406 15.7842 20.125 15.3391 20.125 14.875V10.5H23.625V22.668L20.7211 20.3197Z",
    fill: "#2A2E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsFill);
export default __webpack_public_path__ + "static/media/chats-fill.c3bc0c4fcccf7b86854a8e765c08a2fc.svg";
export { ForwardRef as ReactComponent };